// @flow
import React from 'react'
import * as url from 'url'
import { partition } from 'lodash'

import { Avatar, Buttons } from '@lanetix/unum'

type OrganizationType = {
  organization: {
    avatar_url: string,
    name: string,
    organization_name: string,
    slugs?: Array<string>
  },
  onSelect: Function,
  disabled?: Boolean
}

const Organization = (props: OrganizationType): any => {
  const {
    organization,
    organization: { avatar_url: avatarUrl, name, organization_name: organizationName },
    onSelect,
    disabled
  } = props

  const siteUrl = window.location.href
  const parsedUrl = url.parse(siteUrl, true)
  let ssoUrl
  if (organization.slugs && organization.slugs.length > 0) {
    const [mobileSlug, slug] = partition(organization.slugs, s => s.includes('mobile'))
    const mobile = parsedUrl.query ? parsedUrl.query.mobile : ''
    ssoUrl = mobile ? mobileSlug[0] : slug[0]
  }

  return (
    <li className='organization'>
      <Buttons.PillButton
        className='organization__button'
        contentClassName='organization__wrapper'
        onClick={onSelect}
        block
        disabled={disabled}
      >
        <span className='organization__content'>
          <Avatar className='organization__avatar' src={avatarUrl} />
          <span className='organization__meta'>
            <span className='organization__field organization__name -u-ellipsis'>{organizationName}</span>
            <span className='organization__field organization__org-name -u-ellipsis'>{name}</span>
          </span>
        </span>
      </Buttons.PillButton>
      {organization.slugs && parsedUrl && parsedUrl.host && ssoUrl &&
        <h4>Please click <a href={ssoUrl} className='SSO-link'>{parsedUrl.host + '/' + ssoUrl}</a> for Single Sign On.</h4>}
    </li>
  )
}

Organization.displayName = 'Organization'

export default Organization
